// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d33a141","732":"df470f13","977":"38ece1b3"}[chunkId] + ".chunk.js";
};